import { onDomReady } from '../utils/dom';
import { DropdownMenu } from '../utils/dropdown-menu';

/**
 * @typedef MenuOptions
 * @property {string} selector
 * @property {string} navButton
 * @property {{ element: string, close: string, scroller?: string }} [overlay] — scroller: scrollender Innen-Container;
 *   das Overlay bekommt die Klasse „overflow-bottom", solange darin noch Inhalt unterhalb liegt (Scroll-Verlauf im SCSS)
 */

// C Festival 2027: Hauptnavigation liegt im Vollbild-Overlay (#nav-overlay, Theme-Gruppe vor dem Header),
// der Burger-Button im Header öffnet es auf allen Viewports (Design „C-Festival Menü").
const MainMenu = {
    selector: '#nav-overlay .main-nav',
    navButton: '#header .nav-button',
    overlay: {
        element: '#nav-overlay',
        close: '#nav-close',
        scroller: '#nav-overlay_inside',
    },
};

onDomReady(() => {
    new DropdownMenu(MainMenu);
});
